// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"258":"locale-fr","377":"locale-ru","417":"setting","467":"locale-de_ch","870":"locale-pl"}[chunkId] || chunkId) + "." + {"0":"4027abc5","112":"d2e08cdd","258":"64600d01","377":"7b1d6c5c","417":"9c24179f","467":"994fb86b","626":"e5e40771","870":"66b0717a"}[chunkId] + ".js";
};